























import {
  Component, Prop, PropSync, Vue,
} from 'vue-property-decorator';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import ProbabilisticChart from '@/modules/lcca/views/components/ProbablisticChart.vue';
import {
  ILccaActivityImperial,
  ILccaActivityMetric,
  ILccaAlternativeImperial,
  ILccaAlternativeMetric,
} from '@/modules/lcca/interfaces/lccaCalculated';

@Component({
  components: {
    ProbabilisticChart,
    PxDropdown,
    PxNumberInput,
  },
})
export default class ActivityContainer extends Vue {
  @PropSync('alternative') alt!: ILccaAlternativeImperial | ILccaAlternativeMetric;

  @Prop() activity!: ILccaActivityImperial | ILccaActivityMetric;

  @Prop() index!: number;

  // @PropSync('alternative') alt!: ILccaAlternative;

  sync() {
    this.$emit('input');
  }

  // created(){
  //   this.activity.index = this.index;
  //   console.log("index", this.index)
  // }

  get altBaseId() {
    return `alt_${this.alt.index}`;
  }

  get actId() {
    return this.activity.index;
  }

  get baseId() {
    return `${this.altBaseId}_act_${this.actId}`;
  }

  edit() {
    // console.log("Editing activity", this.baseId);
    this.$emit('edit', this.activity.index);
  }

  copy() {
    /*
    Create a copy of the activity
     */
    // console.log("Copying activity", this.baseId, this.activity.name);

    const newAct = JSON.parse(JSON.stringify(this.activity));

    newAct.id = null;

    // Generate an ID
    // @ts-ignore
    const highestIdValue = Math.max(...this.alt.activities.map((a) => a.index));
    newAct.index = highestIdValue + 1;

    // Generate a name for the copy
    let newName = `${newAct.name} Copy`;

    // If newName already exists then:
    // Iterate through counter values until we have a number that doesn't exist
    let c = 0;
    // @ts-ignore
    while (this.alt.activities.filter((a) => a.name === newName).length > 0) {
      c += 1;
      newName = `${newAct.name} Copy ${c.toString()}`;
    }

    newAct.name = newName;

    this.alt.activities.push(newAct);
    this.$emit('copy');
  }


  logClick(id: string, button: string) {
    console.log("Clicked", id, button)
  }

  mounted() {
    // console.log("Making bar", this.baseId);
    this.$emit('mounted', this.activity.index);
  }
}
